import { FC, Fragment, useCallback } from 'react';

import { MultiValue } from 'react-select';

import { isDefined } from '@hsp/utilities';

import { VirtualSelect } from 'components/select';
import { useFetchTags } from 'pages/audience/shared/hooks/queries';
import { ITag } from 'types/api/tag';
import { ITagProps } from 'types/components/tags';
import { s } from 'utilities/strings';

const Tags: FC<ITagProps> = ({ onSelected, selected }) => {
  const { data, isFetching, isLoading } = useFetchTags();

  const handleSelected = useCallback(
    (item: MultiValue<ITag>) => {
      onSelected?.([...item]);
    },
    [onSelected]
  );

  return (
    <Fragment>
      <VirtualSelect
        closeMenuOnSelect
        getOptionLabel={({ name }) => name}
        getOptionValue={({ id }) => id?.toString() ?? ''}
        isClearable
        isDisabled={isFetching || isLoading}
        isMulti
        onChange={handleSelected}
        options={data}
        placeholder={s(['Site.Select', 'Site.Tag'])}
        value={data?.filter(({ id }) => isDefined(selected?.find((value) => id === value.id)))}
      />
    </Fragment>
  );
};

export default Tags;
